import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseDialog } from '../../../base-dialog';
import { ProfileIntegrationService } from '../../../services/profile/profile-integration.service';

const STEP_TO_PROP_MAP = {
  'download-files': 'download',
  'watch-setup-video': 'setupVideo',
  'display-api-token': 'showApiToken',
  'setup-credentials': 'fields',
  'setup-properties': 'config',
};

const DEFAULT_STEP_ORDER = [
  'select-provider',
  'download-files',
  'display-api-token',
  'watch-setup-video',
  'setup-credentials',
  'setup-properties',
];

@Component({
  selector: 'mandae-integration-setup-dialog',
  templateUrl: './integration-setup-dialog.component.html',
  styleUrls: ['./integration-setup-dialog.component.scss', '../integration-setup-dialog.shared.scss']
})
export class IntegrationSetupDialogComponent extends BaseDialog<IntegrationSetupDialogComponent> implements OnInit {

  private _selectedProvider = null;
  public get selectedProvider() {
    return this._selectedProvider;
  }
  public set selectedProvider(value) {
    this._selectedProvider = value;
    this.stepsForSelectedProvider = value && value.tutorialSteps || this.makeDefaultSteps(value);
    this.nextStep = this.calculateNextStep();
  }

  public currentStep = 'select-provider';

  public nextStep = null;

  public currentStepNumber = 0;

  public get stepsCount(): number {
    if (!this.selectedProvider) {
      return 0;
    }

    let count = 0;
    let step = this.calculateNextStep('select-provider');
    while (step) {
      count++;
      step = this.calculateNextStep(step);
    }

    return count;
  }

  public get showControls(): boolean {
    return !['select-provider', 'setup-credentials', 'setup-properties'].includes(this.currentStep);
  }

  private stepsForSelectedProvider: string[] = DEFAULT_STEP_ORDER;

  constructor(
    dialogRef: MatDialogRef<IntegrationSetupDialogComponent>,
    private profileIntegrationService: ProfileIntegrationService,
  ) {
    super(dialogRef);
  }

  public ngOnInit(): void {
  }

  public selectProvider(provider) {
    this.selectedProvider = provider;

    this.gotoNextStep();
  }

  public gotoNextStep() {
    this.currentStep = this.nextStep;
    this.nextStep = this.calculateNextStep();
    this.currentStepNumber++;

    if (!this.currentStep) {
      this.profileIntegrationService.setIntegrationData(this.selectedProvider.slug)
        .subscribe(() => this.dialogRef.close());
    }
  }

  public gotoPreviousStep() {
    this.currentStep = this.calculatePreviousStep() || 'select-provider';
    this.currentStepNumber--;
    if (this.currentStep === 'select-provider') {
      this.selectedProvider = null;
    }
    this.nextStep = this.calculateNextStep();
  }

  private calculateNextStep(fromStep = this.currentStep): string {
    const index = this.getStepIndex(fromStep);

    if (index === null || index === this.stepsForSelectedProvider.length - 1) {
      return null;
    }

    return this.stepsForSelectedProvider[index + 1];
  }

  private calculatePreviousStep(): string {
    const index = this.getStepIndex();

    if (index === null || index === 0) {
      return null;
    }

    return this.stepsForSelectedProvider[index - 1];
  }

  private getStepIndex(step = this.currentStep) {
    if (!this.selectedProvider) {
      return null;
    }

    const index = this.stepsForSelectedProvider.findIndex(e => e === step);
    if (index === -1) {
      return null;
    }

    return index;
  }

  private makeDefaultSteps(value) {
    return DEFAULT_STEP_ORDER.filter(step => step === 'select-provider' || (value && !!value[STEP_TO_PROP_MAP[step]]));
  }
}
